import s from './styles.scss';
import cx from 'classnames';
import { Container, Icon, enums } from 'edrolo-ui';
import { Skeleton } from './Skeleton';
import { Link, LinkProps } from 'react-router-dom';

export type BreadcrumbsProps = {
  breadcrumbs: Breadcrumb[];
  className?: string;
};

interface Breadcrumb {
  text: string;
  to?: LinkProps['to'];
  asHref?: boolean;
}

const Item = ({ text, to, asHref }: Breadcrumb) => {
  if (asHref && to) {
    return <a href={to as string}>{text}</a>;
  }
  if (!asHref && to) {
    return <Link to={to}>{text}</Link>;
  }
  return <span>{text}</span>;
};

const Breadcrumbs = ({
  breadcrumbs,
  className,
}: BreadcrumbsProps): JSX.Element => {
  return (
    <nav className={cx(s.breadcrumbs, className)}>
      <Container width={enums.Width.FULL}>
        <ol>
          {breadcrumbs.map(({ text, to, asHref = false }, i) => (
            <li key={i}>
              <Item text={text} to={to} asHref={asHref} />
              {i < breadcrumbs.length - 1 && (
                <Icon
                  size={enums.Size.SMALL}
                  name={enums.Icons.CHEVRON_RIGHT}
                  color={enums.ColorTheme.PRIMARY}
                />
              )}
            </li>
          ))}
        </ol>
      </Container>
    </nav>
  );
};

Breadcrumbs.Skeleton = Skeleton;

export { Breadcrumbs };
